import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { Observable, Subject } from 'rxjs';
import { QuoteEmailAddRecFileModalPage } from '../pages/quote/quote-email-add-rec-file-modal/quote-email-add-rec-file-modal.page';

@Injectable({
  providedIn: 'root'
})
export class QuoteEmailAddRecFileModalDeactivateGuard  {

  constructor(
    private router: Router,
    private alertCtrl: AlertController) { }

  canDeactivate(
    page: QuoteEmailAddRecFileModalPage,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canLeavePage(page)
  }

 canLeavePage(page: QuoteEmailAddRecFileModalPage): Observable<boolean> | boolean {

    // return page.filesSizeValid;

    if (page.filesSizeValid) {
      return true;
    }
    else {
      var subject = new Subject<boolean>();
      this.showConfirmationDialog(subject);
      return subject.asObservable();
    }
  }

  async showConfirmationDialog(subject: Subject<boolean>) {
    const confirmDialog = await this.alertCtrl.create({
      header: "Invalid selection",
      message: "The file/s size exceeds the maximum allowed.",
      buttons: [
        {
          text: "Ok",
          role: "cancel",
          handler: () => subject.next(false)
        }
      ]
    });
    await confirmDialog.present();
  }
  
}
